import React from 'react';
import styled from "styled-components";

function Description() {
  return (
      <DescriptionDiv className="App">
        <NormalTextBody>
            In this post, we introduce <b>Neural Vocoder Feature Estimation for Dry Singing Voice Separation</b>.
        </NormalTextBody>
        <TitleTextBody>
        Overview
        </TitleTextBody>
        <NormalTextBody>
        Singing voice separation (SVS) is a task that separates singing voice audio from its mixture with instrumental audio. Previous SVS studies have mainly employed the spectrogram masking method which requires a large dimensionality in predicting the binary masks. In addition, they focused on extracting a vocal stem that retains the wet sound with the reverberation effect. This result may hinder the reusability of the isolated singing voice. This paper addresses the issues by predicting mel-spectrogram of dry singing voices from the mixed audio as neural vocoder features and synthesizing the singing voice waveforms from the neural vocoder. We experimented with two separation methods. One is predicting binary masks in the mel-spectrogram domain and the other is directly predicting the mel-spectrogram. Furthermore, we add a singing voice detector to identify the singing voice segments over time more explicitly. We measured the model performance in terms of dereverberation, separation, and audio quality. The results show that our proposed model outperforms state-of-the-art singing voice separation models in both objective and subjective evaluation except the audio quality.
        </NormalTextBody>
        <FigureDiv>
            <Figureimg src='./OverallArchitecture.png'/>
        </FigureDiv>
        
      </DescriptionDiv>
  );
}



const DescriptionDiv = styled.div`
width: 70%;
margin-top: 50px;
margin-bottom: 50px;
display: flex;
flex-direction: column;
`

const TitleTextBody = styled.body`
font-family: 'Inter';
font-style: normal;
font-weight: 700;
font-size: 22px;
margin-top: 10px;
margin-bottom: 10px;

color: #614E43;
`

const NormalTextBody = styled.body`

font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 18px;
line-height: 24px;

color: #5B5B5B;
`

const FigureDiv = styled.div`
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`

const Figureimg = styled.img`
width: 600px;
margin-left: 50px;
margin-top: 50px;
margin-bottom: 50px;
`

export default Description;